/* import statsApi from "../../api/stats" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  stats: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  stats: state => state.stats,
  stats_fetched: state => state.fetched,
  statsError: state => state.error,
  stats_dataShape: state => state.dataShape,
  stats_extraInfo: state => state.extraInfo,
}
const actions = {
  async DELETE_stats({ commit }, cupon) {
    let apiResponse = await utilsApi.deleteObject("stats", cupon)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STATS_SETTING", apiResponse)
    } else {
      commit("STATS_ERROR")
    }
  },
  async CREATE_stats({ commit }, cupon) {
    let apiResponse = await utilsApi.createObject("stats", cupon)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STATS_SETTING", apiResponse)
    } else {
      commit("STATS_ERROR")
    }
  },
  async SAVE_stats({ commit }, cupon) {
    let apiResponse = await utilsApi.saveObject("stats", cupon)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STATS_SETTING", apiResponse)
      return true
    } else {
      commit("STATS_ERROR")
      return true
    }
  },
  async FETCH_stats({ commit }) {
    let apiResponse = await utilsApi.getObjects("stats")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STATS_SETTING", apiResponse)
      return true
    } else {
      commit("STATS_ERROR")
      return false
    }
  },
}
const mutations = {
  STATS_SETTING: (state, { stats, dataShape, extraInfo }) => {
    console.log(state)
    state.stats = stats
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  STATS_ERROR: state => {
    state.stats = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
